import { useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { serializeFilters } from "./filterUrl";

/*
  Keeps the URL in step with the selection. Restoring happens once, before first render (see index.js); this is the
  write side. `replace`, never `push`: every click would otherwise add a history entry and Back would walk the user
  through every filter state. Returns `truncated` so the page can say when the selection is too long to save.
*/
export const useFilterUrlSync = (filters) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { search, truncated } = useMemo(() => serializeFilters(filters), [filters]);

  useEffect(() => {
    if (location.search === search) { return; }

    navigate({ pathname: location.pathname, search }, { replace: true });
  }, [search]);

  return { truncated };
};
